import React from "react";
import GroupsIcon from "@mui/icons-material/Groups";
import { ThemeProvider } from "@emotion/react";
import theme from "../../../themes/theme";
import { Button } from "@mui/material";
import "./CourseCard.css";
import { useNavigate } from "react-router";
import BASE_URL from "../../../config/api";
export default function CourseCard({ course, userId }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/user/${userId}/course/${course._id}`);
  };
  return (
    <div className="user-card">
      <div className="left-part">
        <p className="course-title">{course.title}</p>
        <div className="icons-container">
          <GroupsIcon fontSize="small" />
          <p style={{ padding: "5px", fontWeight: "600" }}>{course.instructor}</p>
        </div>
        <p className="course-desc">{course.description}</p>
        <ThemeProvider theme={theme}>
          <Button variant="contained" id="start" onClick={handleClick}>
            Start course
          </Button>
        </ThemeProvider>
      </div>
      <div className="right-part">{course.image ? <img alt="coruse-img" className="course-img" src={`${BASE_URL}/courses/${course._id}/image`}></img> : <div>No image available</div>}</div>
    </div>
  );
}
